'use strict';
require('../fess-search/suggestor.js');

/**
 * On click of entire wrapper add the focus class
 */
let onClickSearchHandlers = function() {
	let $searchElement = $('.search-field-wrapper');
	let $searchField = $searchElement.find('input');
	let $closeSearchBtn = $searchElement.find('.fa-times');
	let $openSearchBtn = $searchElement.find('.fa-search');
	let $searchLi = $searchElement.find('li');
	let inputValue;
	let host = window.location.host;

	$openSearchBtn.on('click', function() {
		inputValue = $searchField.val();

		if ($searchElement.hasClass('focus')) {
			window.location.href = 'https://' + host + '/search/?query=' + inputValue;
		} else {
			$searchField.focus();
			$searchElement.addClass('focus');
		}
	});

	$searchField.on('keyup', function(event) {
		inputValue = $searchField.val();

		if (event.keyCode === 13 && inputValue !== '') {
			window.location.href = 'https://' + host + '/search/?query=' + inputValue;
		}
	});

	$searchLi.on('click', function() {
		$searchField.focus();
		$searchElement.addClass('focus');
	});

	$closeSearchBtn.on('click', function() {
		$searchElement.removeClass('focus');
		$searchField.val('');
	});
};

/**
 * Provides suggestions based on the user's input and lets the user select from them.
 */
let suggestorListener = function() {
	if (typeof $.fn.suggestor === 'function') {
		$('#headerSearchQuery').suggestor({
			ajaxinfo: {
				url: '/fess/suggest',
				fn: '_default,content,title',
				num: 10,
				lang: 'en'
			},
			boxCssInfo: {
				border: '1px solid rgba(82, 168, 236, 0.5)',
				'-webkit-box-shadow':
					'0 1px 1px 0px rgba(0, 0, 0, 0.1), 0 3px 2px 0px rgba(82, 168, 236, 0.2)',
				'-moz-box-shadow':
					'0 1px 1px 0px rgba(0, 0, 0, 0.1), 0 3px 2px 0px rgba(82, 168, 236, 0.2)',
				'box-shadow':
					'0 1px 1px 0px rgba(0, 0, 0, 0.1), 0 3px 2px 0px rgba(82, 168, 236, 0.2)',
				'background-color': '#fff',
				'z-index': '10000'
			},
			listSelectedCssInfo: {
				'background-color': 'rgba(82, 168, 236, 0.1)'
			},
			listDeselectedCssInfo: {
				'background-color': '#ffffff'
			},
			minterm: 1,
			adjustWidthVal: 11,
			searchForm: $('#headerSearchBox')
		});
	}
};
/**
 * Generates and places the search html inside of class .search-field-wrapper
 */
let generateSearchHtml = function() {
	let $searchElement = $('.search-field-wrapper');
	let searchHtml = '<div class="row fess-search">' +
		'<div class="col-12 p-0">' +
		'<form id="headerSearchBox"><input type="search" placeholder="Search" class="form-control border-1" ' +
		'aria-label="Search through Shmoop site content" id="headerSearchQuery" /></form>' +
		'<i class="far fa-times"></i>' +
		'<li>Search</li>' +
		'<i class="far fa-search"></i>' +
		'</div><div class="search-label-mobile"><li>Search</li></div>' +
		'</div><!--end row-->';

	$searchElement.html(searchHtml);

	$('#headerSearchBox').on('submit', function(e) {
		e.preventDefault();
		window.location.href = '/search/?query=' + $('#headerSearchQuery').val();
	});

	onClickSearchHandlers();
	suggestorListener();
};

let init = function() {
	generateSearchHtml();
};

module.exports = {
	init: init
};
